import { extensions, readOnly } from '@yola/ws-sdk';
import config from '../constants/config';
import ImageResizeTool from '../components/image-resize-tool';
import getOverlappedMediaContainerByText from '../helpers/get-overlapped-media-container-by-text';

const imageResizeToolSettings = {
  matches(element) {
    if (readOnly.verifiers.isReadOnlyModeEnabled()) {
      return false;
    }

    const settings = extensions.accessors.getExtensionSettings(config.slug);

    if (element.matches(settings.nonResizableElementsSelector)) {
      return false;
    }

    if (
      element.matches(settings.nonResizableElementsSelector) ||
      element.closest(settings.nonResizableRoundedImagesSelector)
    ) {
      return false;
    }
    if (element.matches(settings.imageResizeSelector)) {
      return true;
    }

    const overlappedMediaContainer = getOverlappedMediaContainerByText(element, true);

    if (
      overlappedMediaContainer &&
      overlappedMediaContainer.matches(settings.imageResizeSelector)
    ) {
      return true;
    }

    return false;
  },
  container: ImageResizeTool,
};

export default imageResizeToolSettings;
